/** @jsxImportSource theme-ui */
import theme from "../../config/theme";
import Link from "next/link";

interface NavLinkProps {
  href: string;
  text: string;
}
const NavLink = ({ href, text }: NavLinkProps) => {
  const onPage = /^\/#/.test(href);

  console.log("On page", { href, onPage });

  if (onPage) {
    return (
      <a
        href={href}
        // onClick={(e) => {
        //   e.preventDefault();
        //   document.querySelector(href.replace("/", "")).scrollIntoView({
        //     behavior: "smooth",
        //   });
        // }}
        sx={{ ...theme.links.header, color: "inherit", textDecoration: "none" }}
      >
        {text}
      </a>
    );
  }

  return (
    <Link href={href}>
      <a sx={theme.links.header}>{text}</a>
    </Link>
  );
};

export default NavLink;
